import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CrudService, CustomHttp, ConfigServerService } from '../../../../core';
import { RegiaoGeograficaImediata } from '../regiao-geografica-imediata';
import { RegiaoGeograficaImediataFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class RegiaoGeograficaImediataCrudHttpService {
    resource = 'regiaogeografica/imediata';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todas as regiões geográficas imediatas cadastradas */
    search(): Observable<RegiaoGeograficaImediata[]> {
        return this.crudService.search<RegiaoGeograficaImediata>(this.resource);
    }

    /** Pesquisa todas as regiões geográficas imediatas cadastradas */
    searchWithFilter(filter: RegiaoGeograficaImediataFilter): Observable<RegiaoGeograficaImediata[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<RegiaoGeograficaImediata[]>(this.pathApi, {params});
    }
}
